import { render, staticRenderFns } from "./Appoint.vue?vue&type=template&id=773e3bdc&scoped=true&"
import script from "./Appoint.vue?vue&type=script&lang=js&"
export * from "./Appoint.vue?vue&type=script&lang=js&"
import style0 from "./Appoint.vue?vue&type=style&index=0&id=773e3bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e3bdc",
  null
  
)

export default component.exports